import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '../plugins/i18n.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/components/Home.vue'),
    meta: {
      title: i18n.t('Home'),
      middleware: {
        permission: null
      }
    },
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('@/components/User/Users.vue'),
    meta: {
      title: i18n.t('Users'),
      middleware: {
        permission: 'view_user'
      }
    },
  },
  {
    path: '/currency',
    name: 'currency',
    component: () => import('@/components/Currency/Currencies.vue'),
    meta: {
      title: i18n.t('Currencies'),
      middleware: {
        permission: 'view_currency'
      }
    },
  },
  {
    path: '/supplier',
    name: 'supplier',
    component: () => import('@/components/Supplier/Suppliers.vue'),
    meta: {
      title: i18n.t('Suppliers'),
      middleware: {
        permission: 'view_supplier'
      }
    },
  },
  {
    path: '/supplier-detail-account-statement',
    name: '/supplier-detail-account-statement',
    component: () => import('@/components/Supplier/SupplierDetailAccountStatement.vue'),
    meta: {
      title: i18n.t('Supplier Acc. Stmt.'),
      middleware: {
        permission: 'view_supplier_detail_account_statement'
      }
    },
  },
  {
    path: '/supplier-summary-account-statement',
    name: '/supplier-summary-account-statement',
    component: () => import('@/components/Supplier/SupplierSummaryAccountStatement.vue'),
    meta: {
      title: i18n.t('Supplier Sum. Acc. Stmt.'),
      middleware: {
        permission: 'view_supplier_summary_account_statement'
      }
    },
  },
  {
    path: '/customer',
    name: 'customer',
    component: () => import('@/components/Customer/Customers.vue'),
    meta: {
      title: i18n.t('Customers'),
      middleware: {
        permission: 'view_customer'
      }
    },
  },
  {
    path: '/customer-detail-account-statement',
    name: '/customer-detail-account-statement',
    component: () => import('@/components/Customer/CustomerDetailAccountStatement.vue'),
    meta: {
      title: i18n.t('Customer Acc. Stmt.'),
      middleware: {
        permission: 'view_customer_detail_account_statement'
      }
    },
  },
  {
    path: '/customer-summary-account-statement',
    name: '/customer-summary-account-statement',
    component: () => import('@/components/Customer/CustomerSummaryAccountStatement.vue'),
    meta: {
      title: i18n.t('Customer Sum. Acc. Stmt.'),
      middleware: {
        permission: 'dlshad'
      }
    },
  },
  {
    path: '/item',
    name: 'item',
    component: () => import('@/components/Item/Items.vue'),
    meta: {
      title: i18n.t('Items'),
      middleware: {
        permission: 'view_item'
      }
    },
  },
  {
    path: '/stock',
    name: 'stock',
    component: () => import('@/components/Stock/Stock.vue'),
    meta: {
      title: i18n.t('Stock'),
      middleware: {
        permission: 'view_stock'
      }
    },
  },
  {
    path: '/expense-type',
    name: 'expense-type',
    component: () => import('@/components/ExpenseType/ExpenseTypes.vue'),
    meta: {
      title: i18n.t('Expense Types'),
      middleware: {
        permission: 'view_expensetype'
      }
    },
  },
  {
    path: '/expense',
    name: 'expense',
    component: () => import('@/components/Expense/Expenses.vue'),
    meta: {
      title: i18n.t('Expenses'),
      middleware: {
        permission: 'view_expense'
      }
    },
  },
  {
    path: '/purchase',
    name: 'purchase',
    component: () => import('@/components/Purchase/Purchases.vue'),
    meta: {
      title: i18n.t('Purchases'),
      middleware: {
        permission: 'view_purchase'
      }
    },
  },
  {
    path: '/payment',
    name: 'payment',
    component: () => import('@/components/Payment/Payments.vue'),
    meta: {
      title: i18n.t('Payments'),
      middleware: {
        permission: 'view_payment'
      }
    },
  },
  {
    path: '/sale',
    name: 'sale',
    component: () => import('@/components/Sale/Sales.vue'),
    meta: {
      title: i18n.t('Sales'),
      middleware: {
        permission: 'view_sale'
      }
    },
  },
  {
    path: '/receipt',
    name: 'receipt',
    component: () => import('@/components/Receipt/Receipts.vue'),
    meta: {
      title: i18n.t('Receipts'),
      middleware: {
        permission: 'view_receipt'
      }
    },
  },
  {
    path: '/balance-transfer',
    name: 'balance-transfer',
    component: () => import('@/components/BalanceTransfer/BalanceTransfers.vue'),
    meta: {
      title: i18n.t('Balance Transfer'),
      middleware: {
        permission: 'view_balancetransfer'
      }
    },
  },

  ///////////////////////// Reports 
  {
    path: '/report/profit',
    name: '/report/profit',
    component: () => import('@/components/Report/Profit.vue'),
    meta: {
      title: i18n.t('Profit'),
      middleware: {
        permission: 'dlshad'
      }
    },
  },
  {
    path: '/report/qist',
    name: '/report/qist',
    component: () => import('@/components/Report/Qist.vue'),
    meta: {
      title: i18n.t('Qist'),
      middleware: {
        permission: 'view_qist'
      }
    },
  },
  {
    path: '/report/stock-detail',
    name: '/report/stock-detail',
    component: () => import('@/components/Report/StockDetail.vue'),
    meta: {
      title: i18n.t('Stock Detail'),
      middleware: {
        permission: 'view_stock_detail'
      }
    },
  },
  {
    path: '/report/sold-items-per-supplier',
    name: '/report/sold-items-per-supplier',
    component: () => import('@/components/Report/SoldItemsPerSupplier.vue'),
    meta: {
      title: i18n.t('Sold Items Per Supplier'),
      middleware: {
        permission: 'view_sold_items_per_supplier'
      }
    },
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/404.vue'),
    meta: {
      title: i18n.t('Not found'),
      middleware: {
        permission: null
      }
    },
  },
  {
    path: '*',
    name: 'others',
    component: () => import('@/404.vue'),
    meta: {
      title: i18n.t('Not found'),
      middleware: {
        permission: null
      }
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? to.meta.title + ' | پێشانگای مەدرید ١' : 'پێشانگای مەدرید ١'
  next()
})

export default router
